const KEY_OFFERS = 'OFFERS'
const GET_OFFERS = process.env.REACT_APP_OFFERS ?? ''
const CREATE_OFFERS = process.env.REACT_APP_OFFERS ?? ''
const DELETE_OFFERS = process.env.REACT_APP_OFFERS ?? ''
const UPDATE_OFFERS = process.env.REACT_APP_OFFERS ?? ''

export { KEY_OFFERS, GET_OFFERS, CREATE_OFFERS, DELETE_OFFERS, UPDATE_OFFERS }
